var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "form" } },
    [
      _c("div", { staticClass: "material-icons time-icon" }, [_vm._v("list")]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "header", on: { click: _vm.changeVisible } }, [
          _c("div", { staticClass: "header-titles" }, [
            _c("span", { staticClass: "header-title" }, [
              _vm._v(_vm._s(_vm.$t("calendar.resForm"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "header-sub-title" }, [
              _vm._v(_vm._s(_vm.$t("calendar.resFormDesc"))),
            ]),
          ]),
          _vm._v(" "),
          _vm.contentVisible
            ? _c("div", { staticClass: "material-icons" }, [
                _vm._v("expand_less"),
              ])
            : _c("div", { staticClass: "material-icons" }, [
                _vm._v("expand_more"),
              ]),
        ]),
        _vm._v(" "),
        _vm.contentVisible
          ? _c(
              "div",
              { staticClass: "form-items" },
              [
                _c(
                  "div",
                  { staticClass: "container" },
                  _vm._l(_vm.cloneFormInputs, function (formItem, index) {
                    return _c("div", { staticClass: "form-item" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(formItem.label) +
                          _vm._s(formItem.required ? " *" : "") +
                          "\n                    "
                      ),
                      !formItem.isDefault
                        ? _c(
                            "span",
                            {
                              staticClass: "material-icons form-item-icon edit",
                              on: {
                                click: function ($event) {
                                  return _vm.editFormInput(formItem, index)
                                },
                              },
                            },
                            [_vm._v("edit")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !formItem.isDefault
                        ? _c(
                            "span",
                            {
                              staticClass: "material-icons form-item-icon",
                              on: {
                                click: function ($event) {
                                  return _vm.closeFormInput(index)
                                },
                              },
                            },
                            [_vm._v("close")]
                          )
                        : _vm._e(),
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    staticStyle: { cursor: "pointer" },
                    on: {
                      click: function ($event) {
                        _vm.showModal = true
                      },
                    },
                  },
                  [_vm._v(" + " + _vm._s(_vm.$t("calendar.addAnItem")))]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.showModal || _vm.editModal
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "form-modal",
                showTitle: false,
                "show-footer": false,
              },
              on: { cancel: _vm.closeModal },
            },
            [
              _c("FormModal", {
                attrs: { data: _vm.editFromItem },
                on: {
                  close: _vm.closeModal,
                  input: function ($event) {
                    return _vm.saveItem($event)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }